import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var OpenLinkIcon = function OpenLinkIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 10.8889C20.5942 10.8889 20.3116 11.006 20.1032 11.2143C19.8948 11.4227 19.7778 11.7053 19.7778 12V18.6667C19.7778 18.9614 19.6607 19.244 19.4523 19.4523C19.244 19.6607 18.9614 19.7778 18.6667 19.7778H5.33333C5.03865 19.7778 4.75603 19.6607 4.54766 19.4523C4.33929 19.244 4.22222 18.9614 4.22222 18.6667V5.33333C4.22222 5.03865 4.33929 4.75603 4.54766 4.54766C4.75603 4.33929 5.03865 4.22222 5.33333 4.22222H12C12.2947 4.22222 12.5773 4.10516 12.7857 3.89679C12.994 3.68841 13.1111 3.4058 13.1111 3.11111C13.1111 2.81643 12.994 2.53381 12.7857 2.32544C12.5773 2.11706 12.2947 2 12 2H5.33333C4.44928 2 3.60143 2.35119 2.97631 2.97631C2.35119 3.60143 2 4.44928 2 5.33333V18.6667C2 19.5507 2.35119 20.3986 2.97631 21.0237C3.60143 21.6488 4.44928 22 5.33333 22H18.6667C19.5507 22 20.3986 21.6488 21.0237 21.0237C21.6488 20.3986 22 19.5507 22 18.6667V12C22 11.7053 21.8829 11.4227 21.6746 11.2143C21.4662 11.006 21.1836 10.8889 20.8889 10.8889Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4444 4.22222H18.2L11.2111 11.2C11.107 11.3033 11.0243 11.4262 10.9679 11.5616C10.9115 11.697 10.8824 11.8422 10.8824 11.9889C10.8824 12.1356 10.9115 12.2808 10.9679 12.4162C11.0243 12.5516 11.107 12.6745 11.2111 12.7778C11.3144 12.8819 11.4373 12.9646 11.5727 13.021C11.7081 13.0774 11.8533 13.1064 12 13.1064C12.1467 13.1064 12.2919 13.0774 12.4273 13.021C12.5627 12.9646 12.6856 12.8819 12.7889 12.7778L19.7778 5.8V7.55556C19.7778 7.85024 19.8948 8.13286 20.1032 8.34123C20.3116 8.5496 20.5942 8.66667 20.8889 8.66667C21.1836 8.66667 21.4662 8.5496 21.6746 8.34123C21.8829 8.13286 22 7.85024 22 7.55556V3.11111C22 2.81643 21.8829 2.53381 21.6746 2.32544C21.4662 2.11706 21.1836 2 20.8889 2H16.4444C16.1498 2 15.8671 2.11706 15.6588 2.32544C15.4504 2.53381 15.3333 2.81643 15.3333 3.11111C15.3333 3.4058 15.4504 3.68841 15.6588 3.89679C15.8671 4.10516 16.1498 4.22222 16.4444 4.22222Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
OpenLinkIcon.propTypes = {
  iconColor: PropTypes.string
};
OpenLinkIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "OpenLinkIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var OpenLinkIcon$1 = withTheme(OpenLinkIcon);

export default OpenLinkIcon$1;
